export enum Channel {
  FR = 'default:fr_FR',
  DE = 'default:de_DE',
}
